import React from "react";
import { object, array, string } from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";

import { StoryElement, Link } from "@quintype/components";
import Breadcrumb from "../molecules/breadcrumb";
import AuthorName from "../atoms/Author";

import { getStoryPageDate, findCompleteSectionUrl } from "../../helper/utils";

import "./blank.m.css";

function StoryCard(props) {
  return (
    <div>
      {props.card["story-elements"].map(element => {
        if (element.type === "image") {
          return (
            <figure className="story-element-image qt-image-16x9">
              <img
                alt={element.title || ""}
                src={`https://${props.cdnImage}/${element["image-s3-key"]}?w=400&auto=format%2Ccompress&fmt=webp`}
              />
              <div className="story-element-caption-attribution-wrapper">
                {element.title && <figcaption className="story-element-image-title">{element.title}</figcaption>}
                {element["image-attribution"] && (
                  <figcaption className="story-element-image-attribution"> {element["image-attribution"]}</figcaption>
                )}
              </div>
            </figure>
          );
        } else {
          return <StoryElement element={element} key={element.id} story={props.story} />;
        }
      })}
    </div>
  );
}

function BlankStoryTemplate({ story, sections, cdnImage }) {
  const sectionSlug = findCompleteSectionUrl(get(story, ["sections", 0]), sections);
  const authors = get(story, ["authors"], []);

  const getHeroImage = () => {
    if (story["story-template"] === "video") {
      const getFirstVideoElement =
        story["story-template"] === "video"
          ? story.cards.map(item => item["story-elements"].find(element => element.type === "youtube-video"))
          : [];

      return <iframe src={getFirstVideoElement[0]["embed-url"]}></iframe>;
    } else {
      if (story["hero-image-s3-key"]) {
        return (
          <figure styleName="blank-story-hero-image-wrapper" className="blank-story-image qt-image-16x9">
            <img
              alt={story.headline}
              src={`https://${cdnImage}/${story["hero-image-s3-key"]}?w=400&auto=format%2Ccompress&fmt=webp`}
              styleName="blank-story-hero-image"
            />
          </figure>
        );
      }

      return null;
    }
  };

  return (
    <div styleName="blank-story">
      <Link href={sectionSlug}>
        <Breadcrumb name={get(story, ["sections", 0, "name"])} />
      </Link>
      <h1 styleName="story-heading">{story.headline}</h1>
      {getHeroImage()}
    { authors.length > 0 && <div styleName="author-list">
      {authors.map((author, index) =>(
       <AuthorName
         key={index}
         name={author.name}
         lastIndex={authors.length - 1 === index}
         secondLastIndex={authors.length - 2 === index}
       />
       ))}
       </div> }
      <div styleName="published-time">{getStoryPageDate(story["published-at"])}</div>
      {story["story-template"] !== "video" &&
        story.cards.map(card => <StoryCard cdnImage={cdnImage} key={card.id} card={card} story={story} />)}
      <div className="space-before-next-story" style={{ minHeight: 100 }} />
    </div>
  );
}

function BlankStory(props) {
  return (
    <div className="story-grid">
      <BlankStoryTemplate {...props} />
    </div>
  );
}

BlankStoryTemplate.propTypes = {
  story: object,
  config: object,
  sections: array,
  cdnImage: string
};

BlankStory.propTypes = {
  story: object,
  metypeConfig: object,
  config: object,
  cdnImage: string
};

StoryCard.propTypes = {
  card: object,
  story: object,
  cdnImage: string
};

const mapStateToProps = state => {
  return {
    cdnImage: get(state, ["qt", "config", "cdn-image"], ""),
    sections: get(state, ["qt", "config", "sections"], {})
  };
};

export default connect(mapStateToProps)(BlankStory);
